/* eslint-disable no-dupe-keys */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import Content from "../../../../layout/content/Content";
import { Spinner } from "reactstrap";
import {
    Button,
    Block,
    BlockDes,
    Icon,
    Col,
    Row,
} from "../../../../components/Component";

import Head from "../../../../layout/head/Head";
import OptionM from "../../../components/DynmicOption/OptionM";
import OptionC from "../../../components/DynmicOption/OptionC";
import { DownloadTableExcel } from 'react-export-table-to-excel';
import Evolution from "./Evolution";
import CenterOption from "../../../components/DynmicOption/CenterOption";

const ReportIntake = ({ ...props }) => {
    const [parametersId, setparametersId] = useState(0);
    const [Statee, setStatee] = useState([]);
    const [totall, settotall] = useState([])
    const [load, setload] = useState(true)
    const month1 = ["Test", "JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"]
    const today = new Date();
    const [formData, setFormData] = useState({
        month: sessionStorage.getItem("CurrentMonth") === null ? today.getMonth() : sessionStorage.getItem("CurrentMonth"),
        dummymonth: sessionStorage.getItem("CurrentMonth") === null ? month1[today.getMonth()] : month1[sessionStorage.getItem("CurrentMonth")],
        year: sessionStorage.getItem("CurrentYear") === null ? today.getFullYear() : sessionStorage.getItem("CurrentYear"),
        tomonth: sessionStorage.getItem("CurrentMonth") === null ? today.getMonth() : sessionStorage.getItem("CurrentMonth"),
        todummymonth: sessionStorage.getItem("CurrentMonth2") === null ? month1[today.getMonth()] : month1[sessionStorage.getItem("CurrentMonth2")],
        toyear: sessionStorage.getItem("CurrentYear") === null ? today.getFullYear() : sessionStorage.getItem("CurrentYear"),
        EmploymentRefId: 10,
        state: 0,
        generate: 0,
        CenterId: 0

    });
    const [generate1, setgenerate1] = useState(false);
    const [selectcenter, setselctcenter] = useState(false)
    const tableRef = useRef(null);
    const getdata = async () => {
      
        const sendData = {
            OrgId: Number(2),
            UserId: Number(formData.CenterId),
        }
        await fetch(process.env.REACT_APP_API_LINK + 'api/NCSCDA/DashboardDataAdminDynamic', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    setStatee(data)
                })


    };

 
    const Total = async () => {
        const search = props.location.search;
        const params = new URLSearchParams(search);
        const foo = params.get('data');
        const sendData = {
            ParametersId: Number(foo),
            YearId: Number(formData.year),
            MonthId: Number(formData.month),
            ToYearId: Number(formData.toyear),
            ToMonthId: Number(formData.tomonth)
        }

        await fetch(process.env.REACT_APP_API_LINK + 'api/NCSCDA/Reporttotal', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    if (data.length > 0) {
                    settotall(data[0])
                    }  else {
                        settotall([])
                    }
                    setload(false)
                })

    };
    const onInputChange = (month, year) => {
        setFormData({ ...formData, month: month, year: year });

    };

    const onInputChange2 = (tomonth, toyear) => {
        setFormData({ ...formData, tomonth: tomonth, toyear: toyear });

    };
    const onInputChangeCenter = (e) => {
        // //console.log(e.target.value)
        setselctcenter(false)
        setFormData({ ...formData, CenterId: e.target.value });

    };
    useEffect(() => {
        const search = props.location.search;
        const params = new URLSearchParams(search);
        const foo = params.get('data');
        setparametersId(foo);
        setgenerate1(false)

    }, [window.location.search, parametersId])

    const generate = async () => {
        setload(true)
        Total()
        getdata()
        setFormData({ ...formData, generate: formData.generate + 1 })
        if (formData.CenterId === 0) {
            setselctcenter(true)
        }
        setgenerate1(true)
    }
    return (
        <React.Fragment>
            <Head title={Number(parametersId) === 159 ? "Evaluation" :"Intake" } />

            <Content>
                <Block>
                        <BlockDes className="text-soft">

                            <Row >

                                <Col xl="3" md="3">
                                    <td >
                                        <h5 style={{ color: '#798bff' }}>DA Dashboard</h5>
                                    </td>
                            </Col>
                            <Col xl="3" md="3">
                                <label style={{ color: 'black', fontSize: 14 }}>  Center :  <label style={{ fontWeight: 'bold' }}><CenterOption defaultValuemain={formData.CenterId} catid="42" onInputChange={onInputChangeCenter} namemain="year" mainid="year" /></label></label>
                            </Col>

         
                                <Col xl="3" md="3" >
                                <label style={{ color: 'black', fontSize: 12, fontWeight: 'bold' }}> From:  <label style={{ fontWeight: 'bold' }}><OptionC defaultValuemain={formData.year} catid="42" onInputChange={onInputChange} namemain="year" mainid="year" /></label></label>


                            </Col>

                            <Col xl="3" md="3" >
                                <label style={{ color: 'black', fontSize: 15 }}> To:  <label style={{ fontWeight: 'bold' }}><OptionM onInputChange={onInputChange2} year={formData.year} month={formData.month} /></label></label>


                                </Col>
                            <Col xl="3" md="3" >
                                <Button color="success" style={{ marginTop: 10 }} onClick={() => generate()}>Generate</Button>


                            </Col>
                            </Row>
                       
                         
                        </BlockDes>
                    <hr />
                    {generate1 ?<>
                    <Row>
                        <Col md="2" lg="3">
                          
                        </Col>
                        <Col md="2" lg="3">
                           
                        </Col>
                        <Col md="2" lg="3">
                            
                        </Col>


                        <Col md="2" lg="3">
                            <DownloadTableExcel
                                filename={Number(parametersId) === 159 ? "Evaluation" : Number(parametersId) === 161 ? "Wage Paid Employment" : Number(parametersId) === 162 ? "Training at Centre" : Number(parametersId) === 163 ? "Training Others" : Number(parametersId) === 164 ? "Self Employments" : "Intake"}
                                sheet="users"
                                currentTableRef={tableRef.current}
                            >
                                <Button style={{ float: "right", marginBottom: 10 }} color="info" ><Icon class="icon ni ni-download"></Icon>Export Excel</Button>
                            </DownloadTableExcel>
                        </Col>
                    </Row>
                         
                 

                        <div style={selectcenter === true ? { height: window.innerHeight - 100, width: 'auto', overflow: 'scroll' } : { height: window.innerHeight - 300, width: 'auto', overflow: 'scroll' }} className="table-responsive">
                            <table className="table table-orders" ref={tableRef} style={{ borderCollapse: "separate", borderSpacing: 0, border: '1px solid black' }}>
                                <div style={{ visibility: "hidden", height: 0, width: 0 }} className="table-responsive">
                                    <thead style={{ position: '-webkit-sticky', position: "sticky", top: 0, backgroundColor: '#edecec' }}>

                                        <tr>
                                            <th colSpan="3" style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                Form: {Number(parametersId) === 159 ? "Evaluation Report" : Number(parametersId) === 161 ? "Wage Paid Employment Report" : Number(parametersId) === 162 ? "Training at Centre Report" : Number(parametersId) === 163 ? "Training Others Report" : Number(parametersId) === 164 ? "Self Employments Report" : "Intake Report"}

                                            </th>
                                            <th colSpan="3" style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                From Date: {month1[formData.month]} {formData.year}

                                            </th>
                                            <th colSpan="3" style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                To Date: {month1[formData.tomonth]} {formData.toyear}

                                            </th>
                                        </tr>
                                    </thead>
                                </div>
                            <thead style={{ position: '-webkit-sticky', position: "sticky", top: 0 }}>

                                        <tr>
                                    <th rowSpan="3" style={{ position: '-webkit-sticky', position: "sticky", left: 0, textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                NCSC-DA

                                    </th>
                                    <td colSpan="4" rowSpan="2" style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, fontWeight: "bold" }} >{Number(parametersId) === 159 ? "Evaluation" : Number(parametersId) === 161 ? "Wage Paid Employment" : Number(parametersId) === 162 ? "Training at Centre" : Number(parametersId) === 163 ? "Training Others" : Number(parametersId) === 164 ? "Self Employments" : "Intake"}</td>
                                    <td colSpan="4" rowSpan="2" style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, fontWeight: "bold" }} >{Number(parametersId) === 159 ? "Evaluation" : Number(parametersId) === 161 ? "Wage Paid Employment" : Number(parametersId) === 162 ? "Training at Centre" : Number(parametersId) === 163 ? "Training Others" : Number(parametersId) === 164 ? "Self Employments" : "Intake"}</td>
                                    <td colSpan="21" style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, color: "black", fontWeight: "bold" }} >{Number(parametersId) === 159 ? "Evaluation" : Number(parametersId) === 161 ? "Wage Paid Employment" : Number(parametersId) === 162 ? "Training at Centre" : Number(parametersId) === 163 ? "Training Others" : Number(parametersId) === 164 ? "Self Employments" : "Intake"}</td>
                                        </tr>
                                        <tr>
                                            <td colSpan="3" style={{ textAlign: 'center',border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, fontWeight: "bold" }} >VH</td>
                                            <td colSpan="3" style={{ textAlign: 'center',border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, fontWeight: "bold" }} >HH</td>
                                            <td colSpan="3" style={{ textAlign: 'center',border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, fontWeight: "bold" }} >OH</td>
                                            <td colSpan="3" style={{ textAlign: 'center',border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, fontWeight: "bold" }} >CL</td>
                                            <td colSpan="3" style={{ textAlign: 'center',border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, fontWeight: "bold" }} >MR</td>
                                            <td colSpan="3" style={{ textAlign: 'center',border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, fontWeight: "bold" }} >MD</td>
                                            <td colSpan="3" style={{ textAlign: 'center',border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, fontWeight: "bold" }} >Others</td>

                                        </tr><tr>
                                            <td style={{ textAlign: 'center',border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, fontWeight: "bold", minWidth: 100 }} >Total </td>
                                            <td style={{ textAlign: 'center',border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, fontWeight: "bold", minWidth: 100 }} >Male </td>
                                            <td style={{ textAlign: 'center',border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, fontWeight: "bold", minWidth: 100 }} >Female</td>
                                            <td style={{ textAlign: 'center',border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, fontWeight: "bold", minWidth: 100 }} > Transgender</td>
                                            <td style={{ textAlign: 'center',border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, fontWeight: "bold", minWidth: 100 }} >SC </td>
                                            <td style={{ textAlign: 'center',border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, fontWeight: "bold", minWidth: 100 }} >ST </td>
                                            <td style={{ textAlign: 'center',border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, fontWeight: "bold", minWidth: 100 }} > OBC</td>
                                            <td style={{ textAlign: 'center',border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, fontWeight: "bold", minWidth: 100 }} >Others </td>

                                            <td style={{ textAlign: 'center',border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, fontWeight: "bold", minWidth: 100 }} >Male </td>
                                            <td style={{ textAlign: 'center',border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, fontWeight: "bold", minWidth: 100 }} >Female</td>
                                            <td style={{ textAlign: 'center',border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, fontWeight: "bold", minWidth: 100 }} > Transgender</td>

                                            <td style={{ textAlign: 'center',border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, fontWeight: "bold", minWidth: 100 }} >Male </td>
                                            <td style={{ textAlign: 'center',border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, fontWeight: "bold", minWidth: 100 }} >Female</td>
                                            <td style={{ textAlign: 'center',border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, fontWeight: "bold", minWidth: 100 }} > Transgender</td>

                                            <td style={{ textAlign: 'center',border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, fontWeight: "bold", minWidth: 100 }} >Male </td>
                                            <td style={{ textAlign: 'center',border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, fontWeight: "bold", minWidth: 100 }} >Female</td>
                                            <td style={{ textAlign: 'center',border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, fontWeight: "bold", minWidth: 100 }} > Transgender</td>

                                            <td style={{ textAlign: 'center',border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, fontWeight: "bold", minWidth: 100 }} >Male </td>
                                            <td style={{ textAlign: 'center',border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, fontWeight: "bold", minWidth: 100 }} >Female</td>
                                            <td style={{ textAlign: 'center',border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, fontWeight: "bold", minWidth: 100 }} > Transgender</td>

                                            <td style={{ textAlign: 'center',border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, fontWeight: "bold", minWidth: 100 }} >Male </td>
                                            <td style={{ textAlign: 'center',border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, fontWeight: "bold", minWidth: 100 }} >Female</td>
                                            <td style={{ textAlign: 'center',border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, fontWeight: "bold", minWidth: 100 }} > Transgender</td>

                                            <td style={{ textAlign: 'center',border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, fontWeight: "bold", minWidth: 100 }} >Male </td>
                                            <td style={{ textAlign: 'center',border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, fontWeight: "bold", minWidth: 100 }} >Female</td>
                                            <td style={{ textAlign: 'center',border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, fontWeight: "bold", minWidth: 100 }} > Transgender</td>

                                            <td style={{ textAlign: 'center',border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, fontWeight: "bold", minWidth: 100 }} >Male </td>
                                            <td style={{ textAlign: 'center',border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, fontWeight: "bold", minWidth: 100 }} >Female</td>
                                            <td style={{ textAlign: 'center',border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, fontWeight: "bold", minWidth: 100 }} > Transgender</td>

                                </tr>
                            </thead>
                                        {Statee.length !== 0 ? Statee.map((details) =>
                                           <> <tr style={{ borderCollapse: "separate", borderSpacing: 0, textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', color: 'black' }}>


                                                <th style={{ position: '-webkit-sticky', position: "sticky", left: 0, top: 145, textAlign: 'center', border: '1px solid black', backgroundColor: '#eaf8dd', padding: 10, fontWeight: "bold", minWidth: 100 }}>
                                                      {details.state}

                                                </th>

                                                <Evolution Month={formData.month} generate={formData.generate} tomonth={formData.tomonth} toyear={formData.toyear} year={formData.year} UserId={details.userId} parametersId={parametersId} />
                                               

                                            </tr>
                                                </>
                            ) : <Spinner color="success" />}
                            {selectcenter === true ? load ? <Spinner color="success" /> :
                                <tr style={{ borderCollapse: "separate", borderSpacing: 0, textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', color: 'black' }}>


                                    <th style={{ position: '-webkit-sticky', position: "sticky", left: 0, textAlign: 'center', border: '1px solid black', backgroundColor: '#eaf8dd', padding: 10, fontWeight: "bold", minWidth: 100 }}>
                                        Grand Total

                                    </th>
                                    <>

                                        <td style={{ textAlign: 'center', border: '2px solid black', padding: 10 }} >
                                            <label> {totall.genderTotal3 >= 0 ? totall.genderTotal3 : 0}</label>

                                        </td>

                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                                            <label> {totall.genderMale4 >= 0 ? totall.genderMale4 : 0}</label>

                                        </td>

                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                                            <label> {totall.genderFemale5 >= 0 ? totall.genderFemale5 : 0}</label>

                                        </td>

                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                                            <label> {totall.genderTransgender6 >= 0 ? totall.genderTransgender6 : 0}</label>

                                        </td>

                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                                            <label> {totall.casteSc7 >= 0 ? totall.casteSc7 : 0}</label>

                                        </td>

                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                                            <label> {totall.casteSt8 >= 0 ? totall.casteSt8 : 0}</label>

                                        </td>

                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                                            <label> {totall.casteObc9 >= 0 ? totall.casteObc9 : 0}</label>
                                        </td>

                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                                            <label> {totall.casteOthers10 >= 0 ? totall.casteOthers10 : 0}</label>
                                        </td>

                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                                            <label> {totall.vhmale11 >= 0 ? totall.vhmale11 : 0}</label>

                                        </td>

                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                                            <label> {totall.vhfemale12 >= 0 ? totall.vhfemale12 : 0}</label>

                                        </td>

                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                                            <label> {totall.vhtransgender13 >= 0 ? totall.vhtransgender13 : 0}</label>

                                        </td>

                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                                            <label> {totall.hhmale14 >= 0 ? totall.hhmale14 : 0}</label>

                                        </td>

                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                                            <label> {totall.hhfemale15 >= 0 ? totall.hhfemale15 : 0}</label>

                                        </td>

                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                                            <label> {totall.hhtransgender16 >= 0 ? totall.hhtransgender16 : 0}</label>

                                        </td>

                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                                            <label> {totall.ohmale17 >= 0 ? totall.ohmale17 : 0}</label>

                                        </td>

                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                                            <label> {totall.ohfemale18 >= 0 ? totall.ohfemale18 : 0}</label>

                                        </td>

                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                                            <label> {totall.ohtransgender19 >= 0 ? totall.ohtransgender19 : 0}</label>

                                        </td>

                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                                            <label> {totall.clmale20 >= 0 ? totall.clmale20 : 0}</label>

                                        </td>

                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                                            <label> {totall.clfemale21 >= 0 ? totall.clfemale21 : 0}</label>

                                        </td>

                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                                            <label> {totall.cltransgender22 >= 0 ? totall.cltransgender22 : 0}</label>

                                        </td>

                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                                            <label> {totall.mrmale23 >= 0 ? totall.mrmale23 : 0}</label>

                                        </td>

                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                                            <label> {totall.mrfemale24 >= 0 ? totall.mrfemale24 : 0}</label>

                                        </td>

                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                                            <label> {totall.mrtransgender25 >= 0 ? totall.mrtransgender25 : 0}</label>

                                        </td>

                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                                            <label> {totall.mdmale26 >= 0 ? totall.mdmale26 : 0}</label>

                                        </td>

                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                                            <label> {totall.mdfemale27 >= 0 ? totall.mdfemale27 : 0}</label>

                                        </td>

                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                                            <label> {totall.mdtransgender28 >= 0 ? totall.mdtransgender28 : 0}</label>

                                        </td>
                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                                            <label> {totall.othersMale29 >= 0 ? totall.othersMale29 : 0}</label>

                                        </td>
                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                                            <label> {totall.othersFemale30 >= 0 ? totall.othersFemale30 : 0}</label>

                                        </td>
                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                                            <label> {totall.othersTransgender31 >= 0 ? totall.othersTransgender31 : 0}</label>

                                        </td>
                                    </>




                                    </tr> : null}
                         
                                   
                                </table>

                        </div>
                    </> : <h3>Please Select Month and Year to generate Report!!!</h3>}
                </Block>

            </Content>

        </React.Fragment>
    );
};

export default ReportIntake;
